import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "25",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("mask", {
      id: "a",
      width: "24",
      height: "25",
      x: "0",
      y: "0",
      maskUnits: "userSpaceOnUse",
      style: {"mask-type":"alpha"}
    }, [
      _createElementVNode("path", {
        fill: "#D9D9D9",
        d: "M0 .5h24v24H0z"
      })
    ], -1),
    _createElementVNode("g", { mask: "url(#a)" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        d: "M6 22.5q-.824 0-1.412-.587A1.93 1.93 0 0 1 4 20.5v-12q0-.824.588-1.412A1.93 1.93 0 0 1 6 6.5h2q0-1.65 1.175-2.825T12 2.5t2.825 1.175T16 6.5h2q.824 0 1.413.588Q20 7.675 20 8.5v12q0 .824-.587 1.413A1.93 1.93 0 0 1 18 22.5zm0-2h12v-12h-2v2q0 .424-.287.713A.97.97 0 0 1 15 11.5a.97.97 0 0 1-.713-.287A.97.97 0 0 1 14 10.5v-2h-4v2q0 .424-.287.713A.97.97 0 0 1 9 11.5a.97.97 0 0 1-.713-.287A.97.97 0 0 1 8 10.5v-2H6zm4-14h4q0-.824-.588-1.412A1.93 1.93 0 0 0 12 4.5q-.825 0-1.412.588A1.93 1.93 0 0 0 10 6.5"
      })
    ], -1)
  ])))
}
export default { render: render }